(function () {
  'use strict';

  var DRAWER_SELECTOR = '#halo-cart-sidebar';

  function isB2BCustomer() {
    return ['distributor', 'institution', 'retailer'].indexOf(window.autobrosCustomerType) !== -1;
  }

  function removeDiscountBoxes() {
    document.querySelectorAll('[data-autobros-discount]').forEach(function (box) {
      box.remove();
    });
  }


  function makeB2BInfoBox(context) {
    var type = window.autobrosCustomerType;
    var box = document.createElement('div');
    box.className = 'autobros-b2b-info autobros-b2b-info--' + type;
    box.dataset.autobrosB2bInfo = context;

    var minimum = type === 'distributor' ? '₹50,000' : (type === 'institution' ? '₹15,000' : '₹20,000');
    var title = 'Minimum Order ' + minimum;
    var text = 'Add products worth ' + minimum + ' or more to place your ' + type + ' order at special B2B prices.';
    var badge = String(type || 'B2B').toUpperCase();

    box.innerHTML =
      '<div class="autobros-b2b-info__content">' +
        '<span class="autobros-b2b-info__badge">' + badge + '</span>' +
        '<strong class="autobros-b2b-info__title">' + title + '</strong>' +
        '<span class="autobros-b2b-info__text">' + text + '</span>' +
      '</div>';
    return box;
  }

  function createDrawerB2BInfo(drawer) {
    var info = drawer.querySelector('.previewCartInfo');
    if (!info || info.querySelector('[data-autobros-b2b-info="drawer"]')) return;
    info.insertBefore(makeB2BInfoBox('drawer'), info.firstChild);
  }

  function createCartPageB2BInfo() {
    var totals = document.querySelector('.cart-container .cart-totals');
    if (!totals || totals.querySelector('[data-autobros-b2b-info="page"]')) return;
    var subtotal = totals.querySelector('.cart-total-subtotal');
    var box = makeB2BInfoBox('page');
    if (subtotal) totals.insertBefore(box, subtotal);
    else totals.insertBefore(box, totals.firstChild);
  }


  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function formatCartMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) {
      return window.Shopify.formatMoney(cents, window.money_format);
    }
    return 'Rs. ' + (Number(cents || 0) / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function applicableDiscountCode(cart) {
    var codes = Array.isArray(cart && cart.discount_codes) ? cart.discount_codes : [];
    for (var i = 0; i < codes.length; i += 1) {
      if (codes[i] && codes[i].applicable !== false && codes[i].code) return String(codes[i].code);
    }

    var applications = Array.isArray(cart && cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    for (var j = 0; j < applications.length; j += 1) {
      if (applications[j] && applications[j].title) return String(applications[j].title);
    }

    return '';
  }


  function rejectedDiscountCode(cart, requestedCode) {
    var codes = Array.isArray(cart && cart.discount_codes) ? cart.discount_codes : [];
    var requested = String(requestedCode || '').trim().toLowerCase();
    for (var i = 0; i < codes.length; i += 1) {
      var item = codes[i] || {};
      var code = String(item.code || '');
      if (item.applicable === false && (!requested || code.toLowerCase() === requested)) return code;
    }
    return '';
  }

  function cartAmounts(cart) {
    cart = cart || {};
    var items = Array.isArray(cart.items) ? cart.items : [];
    var originalSubtotal = 0;
    var finalItemsSubtotal = 0;

    items.forEach(function (item) {
      var quantity = Math.max(0, Number(item.quantity || 0));
      var originalLine = Number(item.original_line_price);
      var finalLine = Number(item.final_line_price);

      if (!isFinite(originalLine)) {
        originalLine = Number(item.original_price || item.price || 0) * quantity;
      }
      if (!isFinite(finalLine)) {
        finalLine = Number(item.final_price || item.price || 0) * quantity;
      }

      originalSubtotal += Math.max(0, originalLine);
      finalItemsSubtotal += Math.max(0, finalLine);
    });

    var cartLevelDiscount = 0;
    var applications = Array.isArray(cart.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];
    applications.forEach(function (application) {
      cartLevelDiscount += Math.max(0, Number(application.total_allocated_amount || 0));
    });

    var total = Math.max(0, Number(cart.total_price || 0));
    var apiOriginal = Math.max(0, Number(cart.original_total_price || 0));
    var apiItemsSubtotal = Math.max(0, Number(cart.items_subtotal_price || 0));
    var apiDiscount = Math.max(0, Number(cart.total_discount || 0));

    if (!originalSubtotal) originalSubtotal = apiOriginal || apiItemsSubtotal || total;

    /*
     * Shopify may expose discounts through different fields depending on
     * whether the discount is line-level, cart-level, automatic or code-based.
     * The most reliable customer-facing saving is original merchandise value
     * minus the final cart total. Keep all API fields as fallbacks.
     */
    var lineDiscount = Math.max(0, originalSubtotal - finalItemsSubtotal);
    var calculatedDiscount = Math.max(0, originalSubtotal - total);
    var discount = Math.max(apiDiscount, lineDiscount + cartLevelDiscount, calculatedDiscount);

    /* Prevent rounding/API field differences from making total negative. */
    if (discount > originalSubtotal) discount = originalSubtotal;
    if (!total && originalSubtotal >= discount) total = originalSubtotal - discount;

    return {
      subtotal: originalSubtotal,
      discount: discount,
      total: total
    };
  }

  function cartDiscountAmount(cart) {
    return cartAmounts(cart).discount;
  }

  function syncSummaryFromCart(cart) {
    if (!cart) return;

    var amounts = cartAmounts(cart);
    var discount = amounts.discount;
    var total = amounts.total;
    var subtotal = amounts.subtotal;
    var formattedDiscount = '-' + formatCartMoney(discount);

    document.querySelectorAll('[data-saved-discount-display]').forEach(function (row) {
      row.style.display = '';
      row.setAttribute('data-dis', String(discount));
      var value = row.querySelector('[data-saved-discount-value]');
      if (value) value.textContent = formattedDiscount;
    });

    document.querySelectorAll('#halo-cart-sidebar [data-cart-subtotal]').forEach(function (el) {
      el.textContent = formatCartMoney(subtotal);
      el.setAttribute('data-cart-subtotal-value', String(subtotal));
    });
    document.querySelectorAll('#halo-cart-sidebar .previewCartTotals.total .previewCartTotals-value').forEach(function (el) {
      el.textContent = formatCartMoney(total);
      el.setAttribute('data-cart-total-value', String(total));
    });
    document.querySelectorAll('#halo-cart-sidebar [data-cart-estimated-total]').forEach(function (el) {
      el.textContent = formatCartMoney(total);
    });
    document.querySelectorAll('#halo-cart-sidebar [data-cart-shipping-status]').forEach(function (el) {
      el.textContent = total >= 99900 ? 'Free' : 'Free above ₹999';
      el.setAttribute('data-free-shipping-qualified', total >= 99900 ? 'true' : 'false');
    });
    document.querySelectorAll('.cart-container .cart-total-subtotal .cart-total-value .text').forEach(function (el) {
      el.textContent = formatCartMoney(subtotal);
    });
    document.querySelectorAll('.cart-container .cart-total-grandtotal .cart-total-value .text').forEach(function (el) {
      el.textContent = formatCartMoney(total);
    });
    document.querySelectorAll('.cart-container .cart-total-grandtotal [data-cart-total-value]').forEach(function (el) {
      el.setAttribute('data-cart-total-value', String(total));
    });

    var drawerSubtotal = document.querySelector('#halo-cart-sidebar .previewCartTotals.subTotal');
    var drawerDiscount = document.querySelector('#halo-cart-sidebar [data-saved-discount-display]');
    if (drawerSubtotal && drawerDiscount && drawerDiscount.nextElementSibling !== drawerSubtotal) {
      drawerSubtotal.parentNode.insertBefore(drawerDiscount, drawerSubtotal);
    }

    var pageSubtotal = document.querySelector('.cart-container .cart-total-subtotal');
    var pageDiscount = document.querySelector('.cart-container [data-saved-discount-display]');
    if (pageSubtotal && pageDiscount && pageDiscount.nextElementSibling !== pageSubtotal) {
      pageSubtotal.parentNode.insertBefore(pageDiscount, pageSubtotal);
    }

    var activeCode = applicableDiscountCode(cart);
    if (activeCode) localStorage.setItem('storedDiscount', activeCode);
    else localStorage.removeItem('storedDiscount');

    document.dispatchEvent(new CustomEvent('autobros:cart-totals-synced', {
      detail: { cart: cart, amounts: amounts }
    }));
  }

  function getCart() {
    return fetch(cartUrl('/cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function updateDiscountSummary() {
    return getCart().then(function (cart) {
      syncSummaryFromCart(cart);
      return cart;
    }).catch(function () {});
  }

  function readFreshCart() {
    return fetch(cartUrl('/cart.js') + '?v=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh cart');
      return response.json();
    });
  }

  function waitForDiscountCart(code, attempts) {
    attempts = typeof attempts === 'number' ? attempts : 8;
    var normalized = (code || '').trim().toLowerCase();

    return readFreshCart().then(function (cart) {
      var active = applicableDiscountCode(cart).toLowerCase();
      var amount = cartDiscountAmount(cart);
      var isRemoved = !normalized && !active && amount <= 0;
      var isApplied = normalized && ((active && active === normalized) || amount > 0);

      syncSummaryFromCart(cart);
      if (isRemoved || isApplied || attempts <= 1) return cart;

      return new Promise(function (resolve) {
        window.setTimeout(resolve, 350);
      }).then(function () {
        return waitForDiscountCart(code, attempts - 1);
      });
    });
  }

  function postDiscountUpdate(code) {
    var body = new URLSearchParams();
    body.set('discount', code || '');

    return fetch(cartUrl('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      body: body.toString()
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) {
          throw new Error(data && (data.description || data.message) || 'Unable to update discount');
        }
        return data;
      });
    });
  }

  function discountRedirectUrl(code) {
    var currentPath = window.location.pathname + window.location.search + window.location.hash;
    if (!currentPath || currentPath.indexOf('/discount/') === 0) currentPath = cartUrl('/cart');
    return cartUrl('/discount/') + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(currentPath);
  }

  /*
   * Shopify's discount link can require a real browser navigation in some
   * storefront/accelerated-checkout setups. A background fetch can return 200
   * without committing the discount to the active storefront session.
   */
  function applyDiscountNavigationFallback(code) {
    sessionStorage.setItem('autobrosPendingDiscount', code || '');
    sessionStorage.setItem('autobrosDiscountReturnMessage', '1');
    window.location.assign(discountRedirectUrl(code));
    return new Promise(function () {});
  }

  function updateCartDiscount(code) {
    code = (code || '').trim();
    return postDiscountUpdate(code)
      .then(function () {
        return waitForDiscountCart(code, 8);
      })
      .then(function (cart) {
        if (!code) return cart;

        var active = applicableDiscountCode(cart);
        var amount = cartDiscountAmount(cart);
        if ((active && active.toLowerCase() === code.toLowerCase()) || amount > 0) return cart;

        return applyDiscountNavigationFallback(code);
      });
  }

  function discountIcon() {
    return '<svg class="autobros-discount-box__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M3.5 12.2V5.8c0-1.3 1-2.3 2.3-2.3h6.4c.6 0 1.2.2 1.6.7l6 6a2.3 2.3 0 0 1 0 3.2l-6.4 6.4a2.3 2.3 0 0 1-3.2 0l-6-6c-.4-.4-.7-1-.7-1.6Z" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="8" cy="8" r="1.3" fill="currentColor"/></svg>';
  }

  function makeDiscountBox(context) {
    var box = document.createElement('div');
    box.className = 'autobros-discount-box';
    box.dataset.autobrosDiscount = context;
    box.innerHTML =
      '<div class="autobros-discount-box__field">' +
        discountIcon() +
        '<input class="autobros-discount-box__input" type="text" autocomplete="off" spellcheck="false" placeholder="Enter discount code" aria-label="Discount code">' +
      '</div>' +
      '<button class="autobros-discount-box__button" type="button">Apply</button>' +
      '<div class="autobros-discount-box__message" role="status" aria-live="polite"></div>';

    var input = box.querySelector('.autobros-discount-box__input');
    var button = box.querySelector('.autobros-discount-box__button');
    var message = box.querySelector('.autobros-discount-box__message');

    function render(code) {
      code = (code || '').trim();
      if (code) {
        box.classList.add('is-applied');
        input.value = code;
        input.readOnly = true;
        button.textContent = 'Remove';
        button.setAttribute('aria-label', 'Remove discount code ' + code);
      } else {
        box.classList.remove('is-applied');
        input.value = '';
        input.readOnly = false;
        button.textContent = 'Apply';
        button.setAttribute('aria-label', 'Apply discount code');
      }
    }

    function setMessage(text, isError) {
      message.textContent = text || '';
      box.classList.toggle('has-message', Boolean(text));
      box.classList.toggle('has-error', Boolean(text && isError));
    }

    function setBusy(busy) {
      button.disabled = busy;
      if (busy) button.textContent = 'Please wait';
      else button.textContent = box.classList.contains('is-applied') ? 'Remove' : 'Apply';
    }

    button.addEventListener('click', function () {
      setMessage('', false);

      if (box.classList.contains('is-applied')) {
        setBusy(true);
        updateCartDiscount('')
          .then(function (cart) {
            localStorage.removeItem('storedDiscount');
            render('');
            syncSummaryFromCart(cart);
            setMessage('Discount removed.', false);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          })
          .catch(function (error) {
            setMessage(error.message || 'Discount could not be removed.', true);
          })
          .then(function () { setBusy(false); });
        return;
      }

      var code = input.value.trim();
      if (!code) {
        input.focus();
        setMessage('Enter a discount code.', true);
        return;
      }

      setBusy(true);
      updateCartDiscount(code)
        .then(function (cart) {
          var appliedCode = applicableDiscountCode(cart);
          var savedAmount = cartDiscountAmount(cart);
          var codeMatches = appliedCode && appliedCode.toLowerCase() === code.toLowerCase();
          if (!codeMatches && savedAmount <= 0) {
            var rejectedCode = rejectedDiscountCode(cart, code);
            localStorage.removeItem('storedDiscount');
            render('');
            syncSummaryFromCart(cart);
            input.value = code;
            input.select();
            if (rejectedCode) {
              throw new Error(rejectedCode + ' is valid but not eligible for the current cart. Check products, customer eligibility, minimum purchase and dates in Shopify Discounts.');
            }
            throw new Error('This discount code is invalid or not applicable to this cart.');
          }

          appliedCode = appliedCode || code;
          localStorage.setItem('storedDiscount', appliedCode);
          render(appliedCode);
          syncSummaryFromCart(cart);
          setMessage('Discount applied successfully.', false);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function (error) {
          setMessage(error.message || 'Discount could not be applied.', true);
        })
        .then(function () { setBusy(false); });
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        button.click();
      }
    });

    render('');
    getCart().then(function (cart) {
      var activeCode = applicableDiscountCode(cart);
      var pendingCode = sessionStorage.getItem('autobrosPendingDiscount') || '';
      var returnedFromDiscount = sessionStorage.getItem('autobrosDiscountReturnMessage') === '1';

      render(activeCode);
      syncSummaryFromCart(cart);

      if (returnedFromDiscount) {
        sessionStorage.removeItem('autobrosPendingDiscount');
        sessionStorage.removeItem('autobrosDiscountReturnMessage');

        if (activeCode || cartDiscountAmount(cart) > 0) {
          render(activeCode || pendingCode);
          setMessage('Discount applied successfully.', false);
        } else if (pendingCode) {
          input.value = pendingCode;
          setMessage('This coupon was rejected by Shopify for the current cart. Please verify its Shopify discount conditions.', true);
        }
      }
    }).catch(function () {});
    return box;
  }

  function createDrawerDiscount(drawer) {
    if (isB2BCustomer()) return;
    var info = drawer.querySelector('.previewCartInfo');
    if (!info || info.querySelector('[data-autobros-discount="drawer"]')) return;
    info.insertBefore(makeDiscountBox('drawer'), info.firstChild);
  }

  function createCartPageDiscount() {
    if (isB2BCustomer()) return;
    var totals = document.querySelector('.cart-container .cart-totals');
    if (!totals || totals.querySelector('[data-autobros-discount="page"]')) return;
    var subtotal = totals.querySelector('.cart-total-subtotal');
    var box = makeDiscountBox('page');
    if (subtotal) totals.insertBefore(box, subtotal);
    else totals.insertBefore(box, totals.firstChild);
  }

  function setupOrderSummary(drawer) {
    var toggle = drawer.querySelector('[data-autobros-order-summary-toggle]');
    var summary = drawer.querySelector('[data-autobros-order-summary]');
    if (!toggle || !summary || toggle.dataset.autobrosReady === 'true') return;

    toggle.dataset.autobrosReady = 'true';
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      summary.hidden = expanded;
    });
  }

  function enhanceCheckout(drawer) {
    var checkout = drawer.querySelector('#cart-sidebar-checkout.button-checkout');
    if (!checkout || checkout.dataset.autobrosEnhanced === 'true') return;

    checkout.dataset.autobrosEnhanced = 'true';
    checkout.setAttribute('data-gokwik-compatible-checkout', 'true');

    var text = checkout.textContent.trim();
    if (text && text.indexOf('Secure') === -1) {
      checkout.textContent = 'Buy Now';
    }
  }

  function enhanceDrawer() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;

    drawer.classList.add('autobros-custom-cart-drawer');
    createDrawerDiscount(drawer);
    setupOrderSummary(drawer);
    enhanceCheckout(drawer);
  }

  function observeDrawer() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer || drawer.dataset.autobrosObserver === 'true') return;

    drawer.dataset.autobrosObserver = 'true';
    new MutationObserver(function () {
      window.requestAnimationFrame(enhanceDrawer);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function boot() {
    if (isB2BCustomer()) {
      removeDiscountBoxes();
      var b2bDrawer = document.querySelector(DRAWER_SELECTOR);
      if (b2bDrawer) {
        b2bDrawer.classList.add('autobros-custom-cart-drawer');
        createDrawerB2BInfo(b2bDrawer);
        setupOrderSummary(b2bDrawer);
        enhanceCheckout(b2bDrawer);
      }
      createCartPageB2BInfo();
      observeDrawer();
      return;
    }
    enhanceDrawer();
    createCartPageDiscount();
    updateDiscountSummary();
    observeDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:refresh', boot);
  document.addEventListener('cart:updated', boot);
  document.addEventListener('cart-drawer:refresh', boot);
  document.addEventListener('cart-drawer:open', boot);
})();

/*
 * Shiprocket coupon bridge.
 * Shiprocket injects an inline onclick="shiprocketCheckoutEvents.buyCart(event)".
 * Intercept the first click in capture phase, make sure the Shopify coupon is
 * committed, then trigger one fresh button click so Shiprocket's own inline
 * handler receives a valid event/currentTarget.
 */
(function () {
  'use strict';

  var checkoutInProgress = false;
  var bypassNextShiprocketClick = false;

  function isB2BForShiprocketCoupon() {
    return ['distributor', 'institution', 'retailer'].indexOf(window.autobrosCustomerType) !== -1;
  }

  function currentCouponCode() {
    if (isB2BForShiprocketCoupon()) return '';

    var code = (localStorage.getItem('storedDiscount') || '').trim();
    if (code) return code;

    var appliedInput = document.querySelector(
      '.autobros-discount-box.is-applied .autobros-discount-box__input'
    );
    return appliedInput ? (appliedInput.value || '').trim() : '';
  }

  function commitCouponToShopifySession(code) {
    if (!code) return Promise.resolve();

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    root = root.replace(/\/$/, '');

    var body = new URLSearchParams();
    body.set('discount', code);

    return fetch(root + '/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      body: body.toString()
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to save coupon in cart');

      var discountUrl = root + '/discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(root + '/cart.js?discount_refresh=' + Date.now());

      return fetch(discountUrl, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        redirect: 'follow'
      });
    }).then(function () {
      return fetch(root + '/cart.js?shiprocket_discount=' + Date.now(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh discounted cart');
      return response.json();
    }).then(function (cart) {
      var codes = Array.isArray(cart && cart.discount_codes) ? cart.discount_codes : [];
      var active = codes.some(function (item) {
        return item && item.applicable !== false &&
          String(item.code || '').toLowerCase() === code.toLowerCase();
      });

      if (!active && Number(cart && cart.total_discount || 0) <= 0) {
        throw new Error('Coupon is not active in Shopify cart');
      }

      /* Give Shiprocket's cart observer a moment to read the updated cart. */
      return new Promise(function (resolve) {
        window.setTimeout(resolve, 250);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.sr-headless-checkout')
      : null;

    if (!button) return;

    if (bypassNextShiprocketClick) {
      bypassNextShiprocketClick = false;
      return;
    }

    if (checkoutInProgress) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    var code = currentCouponCode();
    if (!code) return; // No coupon: preserve Shiprocket's normal behavior.

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    checkoutInProgress = true;
    button.disabled = true;

    commitCouponToShopifySession(code)
      .catch(function (error) {
        console.warn('Shiprocket coupon sync:', error);
      })
      .then(function () {
        bypassNextShiprocketClick = true;
        button.disabled = false;
        button.click();
      })
      .finally(function () {
        checkoutInProgress = false;
        button.disabled = false;
      });
  }, true);
})();
